const serverUrl = "https://pluvid.com/planairebackend/";

class AjaxCalls {
	
	getRequest(url) {
		var init = {
		  method: "GET"
		}; 
		var request = new Request(url, init);
		return request;
	}
	
	postRequest(url, data) {
		var init = {
			method: "POST",
			body: data
		}; 
		var request = new Request(url, init);
		return request;
	}
	
	getText(url) {
		return fetch(url)
		.then(function(response) {
			return response.text();
		})
		.catch(function(error) {
			console.log(error);
		});
	}
	
	getJson(url) {		
		return fetch(url)
		.then(function(response) {			
			return response.json();
		})
		.catch(function(error) {
			console.log(error);
		});
	}

	postCharacters(json) {
		var data = new FormData();
		data.append( "characters", JSON.stringify( json ) );
		var request = this.postRequest(serverUrl + "broccoli.php", data);
		return this.getText(request);
	}
	
	postBox(json) {
		var data = new FormData();
		data.append( "box", JSON.stringify( json ) );
		var request = this.postRequest(serverUrl + "broccoli.php", data);
		return this.getText(request);
	}

	postReports(json) {
		var data = new FormData();
		data.append( "reports", JSON.stringify( json ) );
		var request = this.postRequest(serverUrl + "broccoli.php", data);
		return this.getText(request);
	}

	getCharacters() {
		console.log(serverUrl + "characters.json");
		var request = this.getRequest(serverUrl + "characters.json?" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase());
		return this.getJson(request);
	}
	
	getBox() {
		var request = this.getRequest(serverUrl + "box.json?" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase());
		return this.getJson(request);
	}
	
	getReports() {
		var request = this.getRequest(serverUrl + "reports.json?" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase());
		return this.getJson(request);
	}
	
	uploadFile(img) {
		var data = new FormData();
		data.append( "img", img );
		var request = this.postRequest(serverUrl + "images.php", data);
		return this.getText(request);
	}
	
}

var Ajax = new AjaxCalls();

export default Ajax;